import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, EventEmitter, Input, OnInit, Output, OnDestroy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Constant } from 'src/app/constant/constant';
import { ProductService } from 'src/app/services/product.service';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-image-banner',
  templateUrl: './image-banner.component.html',
  styleUrls: ['./image-banner.component.scss']
})
export class ImageBannerComponent implements OnInit, OnDestroy {

  url = '';
  sanitizedUrl = '';


  @Input() value: any;

  @Input() index: any;

  @Input() childeIndex:any

  @Output() fileUploadResult = new EventEmitter();

  @Output() deleteResult = new EventEmitter();


  imageVisible: boolean = true;

  public serverPath = environment.commonImageApi + '/bannerImage/';
  text: string;

  constructor(private snackBar: MatSnackBar,
    private productService: ProductService, private router: Router) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });

      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
 }

  ngOnInit(): void {
  }


  logo() {
    this.imageVisible = false;
  }

  imageDelete: boolean;
  imagesToRemoved: any = [];


  deleteImage(i) {
    this.imageVisible = false;
    this.imageDelete = true;
    let smallImage = "/bannerImage/" + this.value;
    this.imagesToRemoved.push(smallImage);

    this.productService.deleteImage(this.imagesToRemoved).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {

          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.text = "Save"
          this.imageVisible = true;
          this.imageDelete = false;
          this.deleteResult.emit(this.index);
        }
        else {
          this.imageVisible = true;
          this.imageDelete = false;

          this.text = "Save"
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
      },
      (err) => {
        this.imageVisible = true;
      });

  }

  getResult(event) {
    this.imageVisible = true;
    this.fileUploadResult.emit(event);
  }

  cancelUpload() {
    this.imageVisible = true;
  }

  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
